module.exports = __webpack_public_path__ + "images/volvof8eacc313084daaa54c1d924e37d4ab4.png";